(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealNow(el) {
    el.classList.add('is-revealed');
    var children = el.querySelectorAll('[data-cor-reveal-child]');
    if (children.length === 0) return;
    var stagger = parseInt(el.getAttribute('data-cor-reveal-stagger') || '80', 10);
    children.forEach(function (child, i) {
      window.setTimeout(function () {
        child.classList.add('is-revealed');
      }, i * stagger);
    });
  }

  function init() {
    var nodes = document.querySelectorAll('[data-cor-reveal]');
    if (nodes.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      // leave content visible (default), no need to arm
      return;
    }

    // arm the hide-then-reveal animation
    document.documentElement.classList.add('cor-reveal-armed');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealNow(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });

    nodes.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
